import React, {useState, useRef} from "react"
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from 'emailjs-com'

const InquiryForm = () =>{

  const [verified, setVarified] = useState(false)
  function onChange(value) {
    console.log("Captcha value:", value);
    setVarified(true);
  }
  const refform = useRef();
  const sendForm = (e) =>{
    e.preventDefault();
  emailjs.sendForm('service_i5ev5mq','template_qvf7omb',e.target,'3cIb1sgzlfNqwBYS8').then(res=>{
    console.log(res)
    alert("Thank you for submitting the form. We will contact you shortly!")
  }).catch(err=>{
    console.log(err)
  });
  e.target.reset()
};

    return (
    <>
    <section className="container-fluid py-5">
                <div className="col-11 col-md-5 mx-auto py-md-5">
                <div className="text-center">
                <form ref={refform} onSubmit={sendForm} id="contactForm" method="POST" action="#" className="">
      <div className="form-group d-flex mb-4">
        <input type="text" className="ps-4 form-control py-2 rounded-3 border-0 fs-ss-18" id="name" name="name" placeholder="First Name*" required/>
      </div>
      <div className="form-group mb-4">
      <input type="email" className="ps-4 form-control py-2 rounded-3 border-0 fs-ss-18" id="email" name="email" placeholder="Email*" required/>
      </div>
      <div className="form-group mb-4">
      <input type="number" className="ps-4 form-control py-2 rounded-3 border-0 fs-ss-18" id="email" name="email" placeholder="Phone Number*" required/>
      </div>
      <div className="form-group">
      <textarea type="text" className="ps-4 form-control py-2 rounded-3 border-0 fs-ss-18" id="email" name="email" placeholder="Message*" rows={4} required/>
      </div>
      <div className="pt-4">
        <ReCAPTCHA
        sitekey="6LeyzboqAAAAAGcQxKRIM1R2A8sv3rxXSGrfIUnv" 
        onChange={onChange}/>
      <button className='w-100 fw-500 mt-4 rounded-3 border-0 text-white fs-ss-20 py-2 bg-ss-primary'>
        Submit
      </button>
      </div>
    </form>
    </div>
        </div>
    </section>
    </>
    )
}

export default InquiryForm;